var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "bg-white shadow-md hover:shadow-xl rounded-xl transition-all delay-100 duration-75 min-h-80 pb-5",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "h-16 bg-gray-50 flex rounded-xl justify-end items-center text-semibold pl-5 pr-2 space-x-4",
        },
        [_vm._t("header")],
        2
      ),
      _c(
        "div",
        {
          staticClass:
            "h-0 bg-gray-300 flex rounded-xl justify-between items-center text-semibold pl-5 pr-2 mt-10",
        },
        [_vm._t("uploadbutton")],
        2
      ),
      _c(
        "div",
        {
          staticClass:
            "h-0 flex rounded-xl justify-between items-center text-semibold pl-5 pr-2",
        },
        [_vm._t("contractorsheader")],
        2
      ),
      _c(
        "div",
        {
          staticClass:
            "mx-8 p-5 mt-12 border-2 rounded-2xl my-4 w-11/12 flex gap-6",
        },
        [_vm._t("default")],
        2
      ),
      _c("div", [_vm._t("avatarpointers")], 2),
      _c(
        "div",
        {
          staticClass:
            "h-16 flex rounded-xl justify-between items-center text-semibold pl-5 pr-2",
        },
        [_vm._t("recruiting")],
        2
      ),
      _vm.$slots.recruitingcards
        ? _c(
            "div",
            {
              staticClass:
                "mx-8 p-5 border-2 rounded-2xl my-4 w-11/12 flex gap-6",
            },
            [_vm._t("recruitingcards")],
            2
          )
        : _vm._e(),
      _vm.$slots.mycontractors
        ? _c(
            "div",
            {
              staticClass:
                "h-0 flex rounded-xl justify-between items-center text-semibold pl-5 pr-2 -mt-6",
            },
            [_vm._t("mycontractors")],
            2
          )
        : _vm._e(),
      _vm.$slots.mycontractorscards
        ? _c(
            "div",
            {
              staticClass:
                "mx-8 p-5 border-2 rounded-2xl my-4 w-11/12 flex gap-6",
            },
            [_vm._t("mycontractorscards")],
            2
          )
        : _vm._e(),
      _c("div", { staticClass: "flex" }, [
        _c(
          "div",
          { staticClass: "p-5 -mt-6 rounded-2xl flex gap-6 w-44" },
          [_vm._t("mycontractorsavatarpointers")],
          2
        ),
        _c(
          "div",
          { staticClass: "p-5 -mt-6 -ml-5 rounded-2xl flex gap-6 w-44" },
          [_vm._t("mycontractorsavatarpointers2")],
          2
        ),
        _c(
          "div",
          { staticClass: "p-5 -mt-6 -ml-1 rounded-2xl flex gap-6 w-36" },
          [_vm._t("mycontractorsavatarpointers3")],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }